<div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-12">
          <ol class="breadcrumb float-sm-left">
            <li class="breadcrumb-item">
              <a [routerLink]="['/']">
                <i class="fas fa-home"></i>
                Página Inicial</a> 
            </li>
            <li class="breadcrumb-item">
              <a [routerLink]="['/riscos-chaves']">Riscos Chaves</a>
            </li>
            <li class="breadcrumb-item active">Titulo</li>
          </ol>
        </div>
      </div>
    </div>
  </div>

  <div class="card-body p-2">
    <div class="mat-elevation-z4">
      <!-- Toolbar (Cabeçalho) -->
      <mat-toolbar class="table-header">
        <mat-toolbar-row>
       
        </mat-toolbar-row>
      </mat-toolbar>
  
      <!-- Tabela -->
      <table class="mat-elevation-z8 w-100 table table-bordered">
        <thead>
          <tr>
            <th>Subtipo</th>
            <th>Macroprocesso</th>
            <th>Processos</th>
            <th>Magnitude (Risco Inerente)</th>
            <th>Magnitude (Risco Residual)</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
        
              
          <ng-container *ngFor="let subtipo of modelTipoUniversoItens?.itens">
            <!-- Exibe SubTipo -->
            <tr class="tr-cinza">
              <td><strong>{{ subtipo.nome }}</strong></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          
            <!-- Itera sobre os MacroProcessos de cada SubTipo -->
            <ng-container *ngFor="let macro of subtipo.itens">
              <ng-container *ngIf="macro.tipo === 2">
                <tr>
                  <td></td>
                  <td><strong>{{ macro.nome }}</strong></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
          
                <!-- Itera sobre os Processos de cada MacroProcesso -->
                <ng-container *ngFor="let processo of macro.itens">
                  <tr>
                    <td></td>
                    <td></td>
                    <td>{{ processo.nome }}</td>
                    <td>{{ processo.magnitudeRiscoInerente || 0 }}</td>
                    <td>{{ processo.magnitudeRiscoResidual || 0 }}</td>
                    <td class="botoes-acoes">
                      <button type="button" class="
                      btn
                      btn-info
                      btn-xs
                      mr-1
                    "
                                       
                    >
                    <i class="far fa-eye"></i></button>
                      <button type="button" class="btn btn-primary btn-xs mr-1" (click)="abrirPreenchimento(processo.id)"> <i class="far fas fa-pen"></i></button>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>
          
            <!-- Adiciona o "Magnitude" ao final do SubTipo -->
            <tr>
              <td></td>
              <td></td>
              <td><strong>Magnitude</strong></td>
              <td><strong>1 </strong></td>
              <td><strong>2 </strong></td>
              <td></td>
            </tr>
          </ng-container>
          
      
      
        </tbody>
      </table>
      
      
    </div>
  </div>
  
  
  
